<template>
  <div>
    <hr
      class="emd-divider eu-bg_300 eu-my_4"
      v-if="
        !noPadding &&
        entity.logs_url &&
        Object.entries(entity.logs_url) &&
        isEmployee &&
        !isSection
      "
    />
    <div
      v-if="
        entity.logs_url && Object.entries(entity.logs_url).length && isEmployee
      "
    >
      <jade-box
        v-if="isSection"
        class="eu-mt_5 eu-mb_3 el-section eu-fade-in"
      >
        <jade-group-header>{{ title }}</jade-group-header>
        <div class="flex flex-col gap-5 p-5">
          <log-link-content
            :isSection="isSection"
            :entity="entity"
          />
        </div>
      </jade-box>
      <div v-else>
        <jade-text
          variant="heading-xsmall"
          color="high"
        >
          {{ title }}</jade-text
        >
        <div>
          <log-link-content
            :isSection="isSection"
            :entity="entity"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { JadeGroupHeader, JadeBox, JadeText } from '@jade'
import LogLinkContent from './LogLinkContent'
export default {
  name: 'LogLinks',
  components: {
    JadeGroupHeader,
    JadeBox,
    JadeText,
    LogLinkContent
  },
  props: {
    isSection: {
      type: Boolean,
      default: true
    },
    entity: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: false
    },
    noPadding: Boolean
  },
  computed: {
    isEmployee () {
      return this.$store.getters.isEmployee
    },
    classList () {
      var classList = []
      if (this.position) {
        classList.push(`_position_${this.position}`)
      }
      return classList
    }
  }
}
</script>

<style>
._position_initial {
  position: initial !important;
}
</style>
